import styled from '@emotion/styled'
import { Colors } from "../../../colors";
import { Grid } from "@mui/material";
import { mediaQueryMobileLimit } from '../../../utils/constants';
import { FOOTER_HEIGHT } from './components/footer-booking/footer-booking.styled';

export const MakeReservationStyled = {
  Container: styled.div<any>`
    padding-bottom: calc(${FOOTER_HEIGHT}px + 10px);
    flex: 1;
    @media (min-width: ${mediaQueryMobileLimit}px) {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    },
  `,
  ContainerHeaderDetail: styled.div<any>`
    margin-bottom: 14%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  ContainerTrash: styled.div<any>`
    &:hover {
      cursor: pointer;
    }
  `,
  Header: styled(Grid)<any>`
    padding: 15px 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${Colors.White};
    margin-top: 15px;
    margin-bottom: 15px;
    border-radius: 5px
  `,
  ContainerHeaderRooms: styled(Grid)<any>`
    display: flex;
    align-items: center;
  `,
  ContainerButtonReserve: styled(Grid)<any>`
  `,
  HeaderTitle: styled.span<any>`
    font-family: EncodeSans-SemiBold;
    font-size: 14px;
    color: ${Colors.Black};
    line-height: normal;
    vertical-align: top;
  `,
  Body: styled(Grid)<any>`
    padding: 20px;
    @media (min-width: ${mediaQueryMobileLimit}px) {
      padding: 33px;
    };
    display: flex;
    justify-content: space-between;
    background-color: ${Colors.White};
    border-radius: 5px;
  `,
  ContainerCalendar: styled(Grid)<any>`
    padding-right: 50px;
  `,
  ContainerSmallCalendar: styled(Grid)<any>`
    background-color: ${Colors.White};
    margin-bottom: 20px;
  `,
  ContainerDetailEvent: styled(Grid)<any>`
    background-color: ${Colors.White};
    display: flex;
    flex-direction: column;
  `,
  TitleDetailEvent: styled.p<any>`
    font-family: EncodeSans-SemiBold;
    font-size: 14px;
  `,
  SubtitleDetailEvent: styled.p<any>`
    font-family: EncodeSans-SemiBold;
    font-size: 14px;
    color: ${Colors.Unselected};
    margin-top: 13px
  `,
  ContainerEventCalendar: styled.div<any>`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 5px 5px 5px 5px;
    border-radius: 5px;
    background-color: ${(props: any) => props.color};
  `,
  ContainerTitleEventCalendar: styled.div<any>`
    display: flex; 
    justify-content: center;
    align-items: center;
    width: 100%;
  `,
  TitleEventCalendar: styled.p<any>`
    color: ${Colors.White};
    word-wrap: break-word; 
    white-space: normal;
    font-family: EncodeSans-Medium;
    font-size: 12px;
    text-align: center;
  `,
  TimeEventCalendar: styled.p<any>`
    word-wrap: break-word;
    font-family: EncodeSans-Medium;
    color: ${Colors.White};
    font-size: 12px;
    text-align: center;
  `,
  SmallCalendarCustomerEventListContainer: styled.div<any>`
    width: 100%;
    margin-bottom: 15px;
  `,
  SmallCalendarEventDescription: styled.p<any>`
    list-style: disc inside;
    display: list-item;
    font-family: EncodeSans-Regular;
  `,
  SmallCalendarContainerEvent: styled.div<any>`
    display: flex;
    justify-content: space-between; 
    align-items: center;
    margin-bottom: 5px;
  `,
  SmallCalendarContainerTrash: styled.div<any>`
  `,
  SmallCalendarEventCard:  styled.p<any>`
    color: ${(props: any) => props.color};
    font-family: EncodeSans-Regular;
  `,
  LoadingContainer: styled.div<any>`
    margin-bottom: 10px;
  `,
};
